var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", { class: _vm.$style.mobileAppsAd }, [
    _c(
      "div",
      { class: _vm.$style.mobileAdvantages },
      [
        _c("h4", { class: _vm.$style.sloganTitle }, [_vm._v("Become a Boss")]),
        _vm._v(" "),
        _c("h3", { class: _vm.$style.mobileAppAdTitle }, [
          _vm._v(
            "\n      Look up past orders, Faster ordering, and more!\n    "
          )
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { class: _vm.$style.advantagesList },
          _vm._l(_vm.advantages, function(advantage) {
            return _c(
              "li",
              { key: advantage.id, class: _vm.$style.advantagesListItem },
              [
                _c("div", { class: _vm.$style.checkmark }, [
                  _c("svg", {
                    directives: [{ name: "svg", rawName: "v-svg" }],
                    class: _vm.$style.checkmarkWhite,
                    attrs: { symbol: "checkmark-icon" }
                  })
                ]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(advantage.text))])
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "BaseButton",
          {
            class: _vm.$style.advBtn,
            attrs: { "button-style": "Back" },
            on: { click: _vm.goToCreateAccount }
          },
          [_vm._v("\n      Get Started")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { class: _vm.$style.downloadApp }, [
      _c("h3", { class: _vm.$style.mobileAppAdTitle }, [
        _vm._v("\n      Order directly from your mobile phone!\n    ")
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.$style.mobileAppAvailable }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { class: _vm.$style.mobileArrowImage }, [
          _c("svg", {
            directives: [{ name: "svg", rawName: "v-svg" }],
            class: _vm.$style.longArrowIcon,
            attrs: { symbol: "long-arrow" }
          })
        ])
      ]),
      _vm._v(" "),
      _c("img", {
        class: _vm.$style.mobileImage,
        attrs: { src: require("@/assets/img/image_iPhone.jpg"), alt: "iPhone" }
      }),
      _vm._v(" "),
      _c("div", { class: _vm.$style.downloadButtons }, [
        _c("a", { class: _vm.$style.appStoreBtn, attrs: { href: "#" } }, [
          _c("img", {
            attrs: {
              src: require("@/assets/img/app_store.png"),
              alt: "Download on the AppStore"
            }
          })
        ]),
        _vm._v(" "),
        _c("a", { class: _vm.$style.googlePlayBtn, attrs: { href: "#" } }, [
          _c("img", {
            attrs: {
              src: require("@/assets/img/google_play.png"),
              alt: "Get it on Google Play"
            }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("span", { class: _vm.$style.newLabel }, [_vm._v("New")])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h6", [
      _vm._v("Burger Boss mobile apps "),
      _c("span", [_vm._v("NOW AVAILABLE")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/desktop/components/DesktopAdv.vue?vue&type=template&id=2d3624b9&
// module id = null
// module chunks = 